export default __webpack_public_path__ + "static/media/section1-measure3.04ced6c0.svg";